import { useState } from 'react';
import { Link } from 'react-router-dom';
import { trackRegistrationStart } from '../lib/analytics';
import { RegisterStep1 } from '../components/auth/RegisterStep1';
import { RegisterStep2 } from '../components/auth/RegisterStep2';

// Kick off GA4 event once on mount
let _started = false;
function useTrackStart() {
  if (!_started) { _started = true; trackRegistrationStart(); }
}

export function Register() {
  useTrackStart();
  const [step,   setStep]   = useState<1 | 2>(1);
  const [userId, setUserId] = useState('');
  const [email,  setEmail]  = useState('');

  function handleStep1Complete(newUserId: string, newEmail: string) {
    setUserId(newUserId);
    setEmail(newEmail);
    setStep(2);
  }

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: 'var(--bg-base)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '1.5rem',
    }}>
      <div style={{ width: '100%', maxWidth: '420px' }}>

        {/* Back link */}
        <div style={{ marginBottom: '1.25rem' }}>
          {step === 1 ? (
            <Link to="/" style={{ color: 'var(--text-secondary)', textDecoration: 'none', fontSize: 'var(--text-label)', display: 'inline-flex', alignItems: 'center', gap: '0.35rem' }}>
              ← Voltar
            </Link>
          ) : (
            <button
              onClick={() => setStep(1)}
              style={{ background: 'none', border: 'none', color: 'var(--text-secondary)', cursor: 'pointer', fontSize: 'var(--text-label)', display: 'inline-flex', alignItems: 'center', gap: '0.35rem', padding: 0 }}
            >
              ← Voltar
            </button>
          )}
        </div>

        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '1.75rem' }}>
          <Link to="/" style={{ textDecoration: 'none', display: 'inline-block' }}>
            <img src="/logo.svg" alt="Professya" style={{ height: '44px', width: 'auto' }} />
          </Link>
        </div>

        {/* Step progress dots */}
        <div style={{ display: 'flex', justifyContent: 'center', gap: '0.5rem', marginBottom: '1.75rem' }}>
          {[1, 2].map(n => (
            <div key={n} style={{
              width: n <= step ? '2.5rem' : '0.6rem',
              height: '0.35rem',
              borderRadius: '999px',
              background: n <= step ? 'var(--petrol)' : 'var(--line-soft)',
              transition: 'all 0.3s ease',
            }} />
          ))}
        </div>

        <div className="card">
          {step === 1 && (
            <RegisterStep1 onComplete={handleStep1Complete} />
          )}
          {step === 2 && (
            <RegisterStep2
              userId={userId}
              email={email}
              onBack={() => setStep(1)}
            />
          )}
        </div>

      </div>
    </div>
  );
}
